import { PluginRegistry } from "./registry.js";
export { PluginRegistry };
// Map of plugin types to their registries
const registries = {};
/**
 * Get a registry for a specific plugin type, creating it if it doesn't exist
 * This implicitly registers the plugin type if it hasn't been registered yet
 */
export function getRegistry(type) {
    // If the registry doesn't exist yet, create it
    if (!registries[type]) {
        registries[type] = new PluginRegistry();
    }
    return registries[type];
}
// todo remove this tomorrow
// ugly and transitional
function migrate(plugin) {
    if (plugin.type == "patchwork:tool") {
        const tool = plugin;
        if ("supportedDataTypes" in tool) {
            console.warn(plugin.id, plugin.importUrl, "supportedDataTypes was renamed to supportedDatatypes (lowercase t in types). fix it to get rid of this warning");
            tool.supportedDatatypes = tool.supportedDataTypes;
        }
    }
    else if (plugin.type == "patchwork:dataType") {
        console.warn(plugin.id, plugin.importUrl, '"type": "patchwork:dataType" was renamed to patchwork:datatype (lowercase t in type). fix it to get rid of this warning');
        plugin.type = "patchwork:datatype";
    }
}
/**
 * Register plugins
 */
export function registerPlugins(plugins, importUrl) {
    // Register each group with its appropriate registry
    plugins.forEach((plugin) => {
        if (!plugin.type) {
            console.warn("Plugin has no type", plugin);
            return;
        }
        migrate(plugin);
        const registry = getRegistry(plugin.type);
        registry.register(plugin, importUrl);
    });
}
/**
 * Remove all plugins that were registered from a given importUrl.
 * This is the counterpart to registerPlugins() and is used when a module
 * is unloaded.
 */
export function unregisterPlugins(importUrl) {
    for (const registry of Object.values(registries)) {
        for (const plugin of registry.all()) {
            if (plugin.importUrl === importUrl) {
                registry.remove(plugin.id);
            }
        }
    }
}
/**
 * Get all registries
 */
export function getAllRegistries() {
    return new Map(Object.entries(registries));
}
